<script>
import SimulatorStudentDetailResultComponent from '../features/SimulatorStudentDetailResultComponent';

export default {
  name: 'SimulatorStudentDetailResultView',
  components: {},
  extends: SimulatorStudentDetailResultComponent,
  methods: {
    // Traduce el porcentaje de aciertos al badge del design system.
    getStatusBadge(percentage) {
      if (percentage >= 0 && percentage < 70) {
        return 'is_danger';
      }
      if (percentage >= 70 && percentage < 90) {
        return 'is_warning';
      }
      if (percentage > 90 && percentage <= 100) {
        return 'is_success';
      }
      return 'is_purple';
    },
  },
};
</script>
<template>
  <div class="sim_apply_result">
    <template v-if="simulatorResult">
      <!-- Resumen del resultado -->
      <div class="sim_apply_result_hero">
        <div class="sim_apply_result_intro">
          <div class="sim_apply_result_kicker">
            <i class="fas fa-award" /> Resultado del simulador
          </div>
          <h3 class="sim_apply_result_student">
            <i class="fas fa-user-graduate" /> {{ simulatorResult.student }}
          </h3>
          <p class="sim_apply_result_greeting">
            <i class="fas fa-star" /> {{ simulatorResult.greeting }}
          </p>
        </div>

        <div class="sim_apply_result_score">
          <div class="sim_apply_score_ring">
            <span class="sim_apply_score_value">{{ simulatorResult.finalScore }}</span>
            <span class="sim_apply_score_label">Puntos</span>
          </div>
        </div>
      </div>

      <!-- Métricas -->
      <div class="sim_apply_result_metrics">
        <div class="sim_apply_metric">
          <span class="sim_apply_metric_label">Puntaje mínimo</span>
          <span class="sim_apply_metric_value">{{ simulatorResult.lowScore }}</span>
        </div>
        <div class="sim_apply_metric">
          <span class="sim_apply_metric_label">Puntaje máximo</span>
          <span class="sim_apply_metric_value">{{ simulatorResult.topScore }}</span>
        </div>
        <div class="sim_apply_metric">
          <span class="sim_apply_metric_label">Aciertos</span>
          <span class="sim_apply_metric_value">{{ simulatorResult.percentage }}%</span>
        </div>
        <div class="sim_apply_metric">
          <span class="sim_apply_metric_label">Evaluación</span>
          <span class="sim_apply_metric_value">Simulación de práctica</span>
        </div>
      </div>

      <!-- Resultados por sección -->
      <div class="sim_apply_result_table">
        <div class="sim_apply_result_row is_head">
          <div class="sim_apply_result_section_name">
            Sección
          </div>
          <div class="sim_apply_result_badge_label">
            Aciertos / Preguntas
          </div>
        </div>

        <div
          v-for="(section, index) in simulatorResult.sectionResults"
          :key="index"
          class="sim_apply_result_row"
        >
          <div class="sim_apply_result_section_name">
            {{ section.name }}
          </div>

          <span
            class="sim_apply_result_badge"
            :class="getStatusBadge(section.percentage)"
          >
            {{ section.totalSuccess }}/{{ section.totalQuestions }}
          </span>
        </div>
      </div>

      <!-- Acciones finales -->
      <div class="sim_apply_result_actions">
        <button
          type="button"
          class="account_btn_primary"
          @click="onFinish"
        >
          <i class="uil uil-arrow-left" /> Regresar al Inicio
        </button>
      </div>
    </template>

    <div v-loading.fullscreen.lock="isLoading" />
  </div>
</template>
